import { useTranslate } from '@va/localization';
import { Button } from '@va/ui/design-system';
import { useExpandableCardContext } from './expandableCardContext';

export const ExpandButton = () => {
  const { toggle, expanded } = useExpandableCardContext();

  const translate = useTranslate();

  return (
    <Button
      onClick={toggle}
      className='shrink-0 w-full'
      color='tertiary'
      text={expanded ? translate('button.collapse') : translate('button.expand')}
    />
  );
};
